import { Component, Inject } from '@angular/core';
import { AddPatientComponent } from "../add-patient/add-patient.component";
import { RenderFrom } from '../../models/commonmodel';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';

@Component({
  selector: 'app-request-medical-evidence',
  standalone: true,
  imports: [AddPatientComponent],
  templateUrl: './request-medical-evidence.component.html',
  styleUrl: './request-medical-evidence.component.scss'
})
export class RequestMedicalEvidenceComponent {

  memberId: string | undefined;
  renderFrom: string = RenderFrom.REQUEST; // Default to REQUEST mode
  constructor(public dialogRef: MatDialogRef<RequestMedicalEvidenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private memberService : MemberInsurerServiceService) {
    if (data)
      this.memberId = data.memberId;
    console.log(this.memberId)
  }


}
